import * as React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';
import { useParams, useSearchParams } from 'react-router-dom';
import { PageShell, parseOptionalInt, useDocumentTitle } from '../shared';
import { TaskDetailContent } from '../details/TaskDetailContent';

export function AgentTaskPage() {
    useDocumentTitle('Agent Task');

    const { serviceName, taskId } = useParams();
    const [searchParams] = useSearchParams();
    const taskListId = parseOptionalInt(searchParams.get('taskListId'));
    const snapshotId = parseOptionalInt(searchParams.get('snapshotId'));
    const numericTaskId = taskId ? Number.parseInt(taskId, 10) : NaN;

    return (
        <PageShell>
            {!taskListId || !Number.isFinite(numericTaskId) || !serviceName ? (
                <MessageBar messageBarType={MessageBarType.error}>
                    The standalone task page requires both a valid task id and a taskListId query parameter.
                </MessageBar>
            ) : (
                <TaskDetailContent
                    serviceName={serviceName}
                    taskListId={taskListId}
                    taskId={numericTaskId}
                    snapshotId={snapshotId}
                    standalone={true}
                />
            )}
        </PageShell>
    );
}
